<template>
    <div class="container-videos-refine-desktop">
        <ContainerFilterDrawer
            v-if="filters !== null"
            v-bind="{
                showMobileMenu,
                filters,
                updateFilterCurrentValue,
                toggleMobileMenu,
                setShowMobileMenu,
            }"
        ></ContainerFilterDrawer>
        <div class="flex flex-wrap gap-1" v-if="filters !== null">
            <div class="hidden sm:flex sm:items-baseline sm:space-x-6">
                <FormFieldMultiSelect
                    :condensed="true"
                    v-for="filter in shownFilters"
                    :key="filter.field"
                    v-on:input="({name, value}) => { updateFilterCurrentValue({name, value, field: name}) }"
                    :label="filter.name"
                    :name="filter.field"
                    :value="filter.currentValue"
                    :items="filter.values.map(value => ({
                        value: value,
                        text: value,
                    }))"
                ></FormFieldMultiSelect>
                <button
                    v-if="filters?.length > maxFilterLength"
                    @click="toggleMobileMenu"
                    class="group inline-flex items-center justify-center text-sm font-medium text-gray-700 hover:text-gray-900"
                >
                    More
                </button>
            </div>
            <div class="flex-grow"></div>
            <div>
                <FormFieldFilterOrder
                    name="sortOrder"
                    id="sortOrder"
                    itemValue="value"
                    itemText="text"
                    :items="orders"
                    field="order"
                    :value="order"
                    @update="updateSortOrder"
                ></FormFieldFilterOrder>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ContainerVideosRefineDesktop',
    props: [
        // State
        'orders',
        'order',
        'showMobileMenu',
        'filters',

        // Methods
        'updateSortOrder',
        'updateFilterCurrentValue',
        'toggleMobileMenu',
        'setShowMobileMenu',
    ],
    data () {
        return {
            maxFilterLength: 6,
        };
    },
    computed: {
        shownFilters () {
            return this.filters?.filter((filter, index) => index < this.maxFilterLength) || [];
        },
    },
};

</script>
